import MeshManage from '../../meshManage';
import { FRAMEDEPTH, HIGHTLOW_SINKCABINET_HEIGHT, TOPPANELCONFIG, } from '../../utils/kitchenConfig';
/**
 * 获取l1的台面信息
 * @param renderIThis
 * @param lengthXLength 没有高低柜的时候的台面长度
 * @returns l1的台面信息数组
 */
export default function getTopPanelInfo(renderIThis, lengthXLength) {
    var _a;
    const { length1 } = renderIThis.templateJson.bottom;
    const { frames } = length1;
    const sinkCabinetInfo = frames.filter((item) => item.categoryId === 2)[0];
    const sinkCabinetId = (_a = sinkCabinetInfo === null || sinkCabinetInfo === void 0 ? void 0 : sinkCabinetInfo.componentBasic) === null || _a === void 0 ? void 0 : _a.id;
    const sinkCabinetMesh = renderIThis.scene.getMeshByName(sinkCabinetId);
    const sinkCabinetMeshManage = new MeshManage(renderIThis.scene.getMeshByName(sinkCabinetId));
    const { position: { x: meshX, y: meshY } } = sinkCabinetMesh;
    const { x, y } = sinkCabinetMeshManage.getModelSize();
    const sinkHeight = meshY + y;
    // 计算台面的位置  水槽左边的全是低的    右边的全是高的
    const positionLow = {
        x: (meshX + x / 2) / 2,
        y: sinkHeight - HIGHTLOW_SINKCABINET_HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
        z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2, // (水槽柜z+台面伸出来的部分)/2
    };
    const sizeLow = {
        width: Math.abs(meshX + x / 2),
        height: TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    const positionExtra = {
        x: meshX + x / 2 + TOPPANELCONFIG.HEIGHT / 2,
        y: sinkHeight - (HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT) / 2,
        z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
    };
    const sizeExtra = {
        width: TOPPANELCONFIG.HEIGHT,
        height: HIGHTLOW_SINKCABINET_HEIGHT - TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // 高台面信息
    const positionHigh = {
        // 水槽柜位置加上水槽x的一半然后/2 是左边台面的中心点   会多出来一个台面的厚度 全在内侧所以需要偏移台面的位置
        x: (meshX + x / 2 - lengthXLength) / 2 + TOPPANELCONFIG.HEIGHT / 2,
        y: sinkHeight + TOPPANELCONFIG.HEIGHT / 2,
        z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2, // (水槽柜z+台面伸出来的部分)/2
    };
    const sizeHigh = {
        width: lengthXLength - Math.abs((meshX + x / 2)) + TOPPANELCONFIG.HEIGHT,
        height: TOPPANELCONFIG.HEIGHT,
        depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };
    // 返回水槽柜的位置信息，水槽柜靠近原点的距离 以及水槽柜往右的距离
    return [{
            position: positionLow, size: sizeLow,
        }, {
            position: positionExtra, size: sizeExtra,
        }, {
            position: positionHigh, size: sizeHigh,
        }];
}
